import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Header from '../../../../components/header/header';
import GeneralDataSkeleton from '../../generalData/components/generalDataSkeleton/generalDataSkeleton';
import styles from './detailLoadingShell.module.scss';

interface DetailLoadingShellProps {
  codCentro?: string;
}

const DetailLoadingShell = ({ codCentro }: DetailLoadingShellProps) => {
  return (
    <div
      className={styles.page}
      data-testid='detail-loading-shell'
      aria-busy='true'
    >
      <Header>
        <div className={styles.headerContent}>
          <div className={styles.projectInfo}>
            <div className={styles.backButton} aria-hidden='true'>
              <ArrowBackIosIcon />
            </div>
            <div className={styles.projectName}>
              <span className={styles.projectCode}>{codCentro || ' '}</span>
              <span className={styles.namePlaceholder} />
            </div>
            <span className={styles.statusPlaceholder} />
          </div>

          <div className={styles.tabs} aria-label='Loading project sections'>
            {Array.from({ length: 14 }, (_, index) => (
              <span className={styles.tabPlaceholder} key={`tab-${index}`} />
            ))}
          </div>
        </div>
      </Header>

      <main className='contentFullDetail'>
        <GeneralDataSkeleton />
      </main>
    </div>
  );
};

export default DetailLoadingShell;
